/* AE Blog Carousel — same scroll engine as the video carousel */
(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', function () { fn(document); }); })(function () {
  document.querySelectorAll('[data-ae-blog-carousel]').forEach(function (root) {
    if (root.dataset.aeBound === 'true') return;
    root.dataset.aeBound = 'true';
    var viewport = root.querySelector('[data-ae-bc-viewport]');
    var track = root.querySelector('[data-ae-bc-track]');
    var slides = Array.prototype.slice.call((track && track.children) || []);
    var prev = root.querySelector('[data-ae-bc-prev]');
    var next = root.querySelector('[data-ae-bc-next]');
    var progress = root.querySelector('[data-ae-bc-progress]');

    function step() {
      var slide = slides[0];
      if (!slide) return (viewport && viewport.clientWidth) || 1;
      var style = getComputedStyle(slide);
      return slide.getBoundingClientRect().width + parseFloat(style.paddingLeft || '0');
    }

    function update() {
      if (!viewport) return;
      var max = viewport.scrollWidth - viewport.clientWidth;
      var ratio = max <= 0 ? 1 : viewport.scrollLeft / max;
      if (progress) {
        progress.style.width = Math.min(100, Math.max(8, ratio * 100)) + '%';
      }
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= max - 1;
    }

    if (prev) prev.addEventListener('click', function () {
      if (viewport) viewport.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      if (viewport) viewport.scrollBy({ left: step(), behavior: 'smooth' });
    });

    if (viewport) viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    function resetToStart() {
      if (!viewport) return;
      viewport.scrollLeft = 0;
      update();
    }
    [0, 50, 150, 350, 700].forEach(function (delay) { setTimeout(resetToStart, delay); });
    window.addEventListener('pageshow', resetToStart);
    window.addEventListener('load', resetToStart);
  });
});
